import StorageUtils from '@spothero/utils/storage';
import { StorageDurations, StorageKeys, StorageTypes, } from 'common/constants/storageKeys';
import { v4 as uuidV4 } from 'uuid';
// We are going to assume this is only used on the browser for this.
// SSR may need to use this at some point but we can discuss this at the future
// Storage utils set does JSON.stringify which results in a double wrapper
export const getWebExperimentCookie = (defaultValue) => {
    const shExperimentCookie = StorageUtils.get(StorageKeys.EXPERIMENTID, StorageTypes.COOKIE);
    if (!shExperimentCookie || typeof shExperimentCookie !== 'string') {
        // generate cookie
        const newCookie = defaultValue || uuidV4();
        // Set cookies are set in days
        StorageUtils.set(StorageKeys.EXPERIMENTID, newCookie, StorageTypes.COOKIE, StorageDurations.YEAR);
        return newCookie;
    }
    return shExperimentCookie.replaceAll('^"|"$', '');
};
